/* eslint-disable */
import { AxiosResponse } from 'axios';
import { APIError } from '../types/types';
import { DATE_FORMAT, STORE_NUMBER_KEY } from '../constants/constants';
import { format } from 'date-fns';
export const sanitizeURL = (url: string): string => {
  if (!url) {
    return '';
  }

  const badURLRegex = RegExp('^((https)|(http)):/{3,}');
  const isBadURL = badURLRegex.test(url);

  if (isBadURL) {
    return 'https://' + url.replace(badURLRegex, '');
  }

  return url;
};

export const getErrorMessage = (response?: AxiosResponse<APIError>) => {
  if (response?.status === 400 && response?.data.errors[0].code) {
    return response?.data.errors[0].message;
  }

  return null;
};

export const daysUntilSunday = (today: Date = new Date()): number => {
  const todayIndex = today.getDay() + 1;
  return (7 - todayIndex) % 7;
};

export const formatMoney = (amount: string | number | null | undefined) => {
  if (amount === null || amount === undefined || isNaN(amount as number)) {
    return '$0.00';
  }   

  return `$${Number(amount).toFixed(2)}`;
};
export const formatPhoneNumber = (phone: string, isMasked?: boolean) => {
  if (phone && isMasked) return `(***) ***-****`;
  if (!phone || phone.includes('-')) return phone;

  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
};
export const orderByFieldAndValue = (
  value: string,
  fieldName: string,
  arrayToOrder: any[]
) => {
  if (!arrayToOrder || !arrayToOrder.length || !fieldName) return arrayToOrder;
  return arrayToOrder.sort((a) => (a[fieldName] === value ? -1 : 1));
};
export const formatStringDateHoursAndMinutes = (
  dateAsString: string | undefined   
): string => {
  try {
    if (dateAsString && isValidDate(new Date(dateAsString))) {
      const split1 = dateAsString.split('T');
      if (!split1[1]) {
        return '';
      }
      const split2 = split1[1].split(':');
      if (!split2[1]) {
        return '';
      }

      const hours = Number(split2[0]);
      const minutes = split2[1];

      let hoursToDisplay = hours % 12;
      let meridian = 'AM';

      if (hours >= 12) {
        meridian = 'PM';
      }
      if (hoursToDisplay === 0) {
        hoursToDisplay = 12;
      }

      return `${hoursToDisplay}:${minutes} ${meridian}`;
    }

    return '';
  } catch {
    return '';
  }
};

export const getSelectedStore = () =>
  sessionStorage.getItem(STORE_NUMBER_KEY) || '';

export const formatDate = (date: Date, dateFormat = DATE_FORMAT): string => {
  if (isValidDate(date)) return format(date, dateFormat);
  return '';
};

export function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d.getTime());
}
export const formatDateString = (
  dateAsString: string | undefined,
  returnedFormat?: string
): string => {
  if (!dateAsString || typeof dateAsString !== 'string') {
    return '';
  }
  let dateWithoutHours;
  if (dateAsString.includes('T')) {
    dateWithoutHours = dateAsString.split('T')[0];
  } else {
    dateWithoutHours = dateAsString;
  }

  // [0] = 'yyyy'; [1] = 'mm'; [2] = 'dd'
  let dateAsArray = [] as string[];
  if (dateWithoutHours.includes('-')) {
    dateAsArray = dateWithoutHours.split('-');
  } else if (dateWithoutHours.includes('/')) {
    dateAsArray = dateWithoutHours.split('/');
  }

  if (dateAsArray?.length !== 3) {
    return '';
  }

  if (returnedFormat === 'MM-dd-yyyy') {
    return `${dateAsArray[1]}-${dateAsArray[2]}-${dateAsArray[0]}`;
  }
  // mm/dd/yyyy
  return `${dateAsArray[1]}/${dateAsArray[2]}/${dateAsArray[0]}`;
};

export const toLocaleStringWithMinutes = (date: Date): string => {
  if (isValidDate(date))
    return date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

  return '';
};
